/** Barre d'onglets du PDA, en bas, sans défilement : Scan, Réception, Inventaire, Stocks, Plus. */
import type { ElementType } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Boxes, ClipboardCheck, MoreHorizontal, PackagePlus, ScanBarcode } from 'lucide-react';
import { isTabActive, PDA_TABS } from '@/features/pda/pdaNav';
import { cn } from '@/lib/utils';

const ICONS: readonly ElementType[] = [ScanBarcode, PackagePlus, ClipboardCheck, Boxes];

const itemClass = (active: boolean) =>
  cn(
    'flex min-h-16 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 text-[13px] font-semibold',
    active ? 'text-primary' : 'text-muted-foreground',
  );

export function PdaBottomNav({ onMore, moreOpen }: { onMore: () => void; moreOpen: boolean }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  return (
    <nav
      aria-label="Navigation du PDA"
      data-testid="pda-bottom-nav"
      className="fixed inset-x-0 bottom-0 z-40 flex border-t border-border bg-card pb-[env(safe-area-inset-bottom)]"
    >
      {PDA_TABS.map((tab, index) => {
        const Icon = ICONS[index];
        const active = isTabActive(tab, pathname, search);
        return (
          <button
            key={tab.to}
            type="button"
            aria-current={active ? 'page' : undefined}
            onPointerDown={(event) => event.preventDefault()}
            onClick={() => navigate(tab.to)}
            className={itemClass(active)}
          >
            <Icon className="h-6 w-6" />
            {tab.label}
          </button>
        );
      })}
      <button
        type="button"
        aria-expanded={moreOpen}
        data-testid="pda-more-open"
        onPointerDown={(event) => event.preventDefault()}
        onClick={onMore}
        className={itemClass(moreOpen)}
      >
        <MoreHorizontal className="h-6 w-6" />
        Plus
      </button>
    </nav>
  );
}
